import { useQuery } from "@tanstack/react-query";
import axiosManager from "services/axiosManager";

const useGetSupportArticles = () => {
    const {
        data: supportArticles,
        error,
        isLoading,
    } = useQuery({
        queryKey: ["supportArticles"],
        queryFn: () =>
            axiosManager.get$("/support/articles").then((res) => res.data),
    });

    return { supportArticles, error, isLoading };
};

export default useGetSupportArticles;
